export function verificaParametroDaUrl (key){

    const parametros = new URLSearchParams(document.location.search);
    const valorParametro = parametros.get(key)
    
    return valorParametro;
}